var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDraft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43013"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.7907 12.6022L18.6479 10.4593C18.5816 10.393 18.5028 10.3403 18.4162 10.3044C18.3295 10.2685 18.2367 10.25 18.1429 10.25C18.0491 10.25 17.9562 10.2685 17.8695 10.3044C17.7829 10.3403 17.7042 10.393 17.6379 10.4593L11 17.0971V20.25H14.1529L20.7907 13.6122C20.8571 13.5459 20.9097 13.4671 20.9456 13.3805C20.9815 13.2938 21 13.201 21 13.1072C21 13.0134 20.9815 12.9205 20.9456 12.8338C20.9097 12.7472 20.8571 12.6685 20.7907 12.6022ZM13.5614 18.8215H12.4286V17.6887L16 14.1172L17.1328 15.25L13.5614 18.8215ZM18.1429 14.24L17.0101 13.1072L18.1429 11.9744L19.2756 13.1072L18.1429 14.24Z",
    fill: "#0DA06E",
    stroke: "#0DA06E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12.429 10.25H5.28613V11.6786H12.429V10.25Z",
    fill: "#0DA06E",
    stroke: "#0DA06E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.8576 5.96436H5.28613V7.39293H13.8576V5.96436Z",
    fill: "#0DA06E",
    stroke: "#0DA06E",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.1429 1.67857C18.1424 1.29982 17.9918 0.936714 17.724 0.668899C17.4562 0.401084 17.093 0.250435 16.7143 0.25H2.42858C2.04983 0.250435 1.68672 0.401084 1.4189 0.668899C1.15109 0.936714 1.00044 1.29982 1 1.67857V10.9643C0.998458 12.3888 1.38488 13.7869 2.11781 15.0084C2.85073 16.23 3.90247 17.2289 5.16015 17.8979L8.85715 19.8692V18.25L5.83258 16.6374C4.80354 16.09 3.943 15.2727 3.34329 14.2732C2.74359 13.2738 2.42737 12.1299 2.42858 10.9643V1.67857H16.7143V8.10715H18.1429V1.67857Z",
    fill: "#0DA06E",
    stroke: "#0DA06E",
    strokeWidth: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraft);
export default __webpack_public_path__ + "static/media/draft.082111ab9d0663beaa46ac9a3140fbac.svg";
export { ForwardRef as ReactComponent };